require('./externalTransferFund.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');

// @components
const ExternalTransferFundStep2 = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundStep2/externalTransferFundStep2');
const ExternalTransferFundStep3 = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundStep3/externalTransferFundStep3');
const ExternalTransferFundStep4 = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundStep4/externalTransferFundStep4');
const ExternalTransferFundSuccess = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundSuccess/externalTransferFundSuccess');
const ExternalTransferFundDetails = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundDetails/externalTransferFundDetails');
const ExternalTransferFundHelp = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundHelp/externalTransferFundHelp');
const ContactCenterExternalTransferFundStep4 = require('components/contactCenter/hireInvestmentFunds/externalTransferFund/contactCenterExternalTransferFundStep4/contactCenterExternalTransferFundStep4');
const ExternalTransferFundStep3New = require('components/hireInvestmentFunds/externalTransferFund/externalTransferFundStep3New/externalTransferFundStep3New');
const { BrokerInvestmentSpecialist } = require('components/broker/brokerInvestmentSpecialist/brokerInvestmentSpecialist');
const { ContentBox } = require('commonsComponents/contentBox');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

class ExternalTransferFund extends React.Component {
    constructor(props) {
        super(props);
        this.onCancel = this.onCancel.bind(this);
        this.onFinish = this.onFinish.bind(this);
        this.handleHideHelp = this.handleHideHelp.bind(this);
    }

    componentWillReceiveProps(newProps) {
        const { immExternalTransferFund, onFinish } = newProps;
        const finished = immExternalTransferFund.get('submitSuccessful');
        const visibleStepValid = immExternalTransferFund.getIn(['steps', 3, 'valid']);
        const error = immExternalTransferFund.get('error');

        if (visibleStepValid && !finished && !error) {
            onFinish();
        }
    }

    componentWillUnmount() {
        const { resetPrintedIndicators } = this.props;
        resetPrintedIndicators();
    }

    onCancel() {
        this.props.onCancel();
    }

    onFinish() {
        this.props.onFinish();
    }

    buildExternalTransferFundStep4() {
        const {
            immExternalTransferFund,
            immBrokerMyInvestments,
            setCheckbox,
            immBrokerFundLegalDocument,
            fetchLegalDocuments,
            requestProfile,
            immProfileFields,
            immPreContractualMail,
            sendPreContractualMail,
            setLegalInformationConf,
            resetLegalInformation,
            resetPrecontractualMail,
            setDocumentsRead,
            postValidation
        } = this.props;

        if(!__CONTACT_CENTER__) {
            return (
                <ExternalTransferFundStep4
                    immExternalTransferFund={immExternalTransferFund}
                    immBrokerFundLegalDocument={immBrokerFundLegalDocument}
                    setCheckbox={setCheckbox}
                    postValidation={postValidation}
                    fetchLegalDocuments={fetchLegalDocuments}
                    immBrokerMyInvestments={immBrokerMyInvestments}
                    setDocumentsRead={setDocumentsRead}
                />
            )
        }

        return (
            <ContactCenterExternalTransferFundStep4
                immExternalTransferFund={immExternalTransferFund}
                immBrokerFundLegalDocument={immBrokerFundLegalDocument}
                sendPreContractualMail={sendPreContractualMail}
                resetPrecontractualMail={resetPrecontractualMail}
                immPreContractualMail={immPreContractualMail}
                immProfileFields={immProfileFields}
                requestProfile={requestProfile}
                setCheckbox={setCheckbox}
                postValidation={postValidation}
                fetchLegalDocuments={fetchLegalDocuments}
                immBrokerMyInvestments={immBrokerMyInvestments}
                setLegalInformationConf={setLegalInformationConf}
                resetLegalInformation={resetLegalInformation}
            />
        )
    }

    buildWizard() {
        const {
            immExternalTransferFund,
            validateStep,
            setVisibleStep,
            setWillCancel,
            handleInputSearchProductSelected,
            handleResetSearchProductSelected,
            handleSetSearchProductSelected,
            setInstitutionName,
            setAccount,
            setNif,
            setHasNif,
            immBrokerMyInvestments,
            setType,
            setSubtype,
            setAmount,
            setDestinationFund,
            getInterveners,
            getOriginFund,
            immAccounts,
            resetAmountDirty,
            getStocksContracts,
            onHandleRetry,
        } = this.props;
        const immSteps = immExternalTransferFund.get('steps');
        const stepsAmount = immSteps.size;
        const visibleStep = immExternalTransferFund.get('visibleStep');
        const wizardClass = 'external-transfer-fund__wizard';
        const finalText = 'broker-hireInvestmentSubmit';
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: this.onFinish,
            cancel: this.onCancel
        };
        const fundId = immExternalTransferFund.getIn(['steps', 2, 'destinationFund']);
        const immFundSelected = immBrokerMyInvestments.getIn(['products', 'funds', 'stocks']).find( fund => fund.get('id') === fundId );
        const linkedToRobo = !!immFundSelected ? immFundSelected.get('isBlockedByRobo') : false;
        const externalTransferFundStep4 = this.buildExternalTransferFundStep4();
        const isLoadingExternalTransferFund = immExternalTransferFund.getIn(['isLoading']);
        const step1ButtonDisabled = !immExternalTransferFund.getIn(['steps', 1, 'label']);

        const pasoProceso = visibleStep && visibleStep !== 1
        ? `paso_${visibleStep}`
        : 'inicio';
        const tealium = visibleStep
        ? {
            pasoProceso: pasoProceso,
        } : null;

        return (
            <Wizard
                wizardClass={wizardClass}
                actions={actions}
                stepsAmount={stepsAmount}
                visibleStep={visibleStep}
                immSteps={immSteps}
                tealium={tealium}
                isTaggingSecondVersion
            >
                <WizardStep position="first" cancelButton={true} nextButtonDisabled={step1ButtonDisabled}>
                    <ExternalTransferFundStep2
                        immBrokerMyInvestments={immBrokerMyInvestments}
                        immExternalTransferFund={immExternalTransferFund}
                        getStocksContracts={getStocksContracts}
                        onHandleRetry={onHandleRetry}
                        handleInputSearchProductSelected={handleInputSearchProductSelected}
                        handleResetSearchProductSelected={handleResetSearchProductSelected}
                        handleSetSearchProductSelected={handleSetSearchProductSelected}
                        setInstitutionName={setInstitutionName}
                        setAccount={setAccount}
                        setNif={setNif}
                        setHasNif={setHasNif}
                        />

                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton
                    isLoading={immExternalTransferFund.get('mustRunMifid') || immExternalTransferFund.get('isFetchingInteveners')}
                    nextButtonDisabled={!fundId || linkedToRobo}
                >
                    <ExternalTransferFundStep3
                        immAccounts={immAccounts}
                        immExternalTransferFund={immExternalTransferFund}
                        immBrokerMyInvestments={immBrokerMyInvestments}
                        setType={setType}
                        setAmount={setAmount}
                        setDestinationFund={setDestinationFund}
                        getOriginFund={getOriginFund}
                        resetAmountDirty={resetAmountDirty}
                        onStartMifid={this.props.onStartMifid}
                        onCancelMifid={this.props.onCancelMifid}
                        onResetMifid={this.props.onResetMifid}
                        getInterveners={getInterveners}
                    />
                </WizardStep>
                <WizardStep
                    position="middle"
                    cancelButton
                    nextButtonDisabled={false}
                >
                    <ExternalTransferFundStep3New
                        immAccounts={immAccounts}
                        immExternalTransferFund={immExternalTransferFund}
                        immBrokerMyInvestments={immBrokerMyInvestments}
                        setType={setType}
                        setSubtype={setSubtype}
                        setAmount={setAmount}
                        setDestinationFund={setDestinationFund}
                        getOriginFund={getOriginFund}
                        resetAmountDirty={resetAmountDirty}
                        onStartMifid={this.props.onStartMifid}
                        onCancelMifid={this.props.onCancelMifid}
                        onResetMifid={this.props.onResetMifid}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton
                    immFinalButton={finalText}
                    addLoadingBehaviour
                    isLoading={isLoadingExternalTransferFund}
                >
                    {externalTransferFundStep4}
                </WizardStep>
            </Wizard>
        );
    }

    handleHideHelp() {
        this.props.onHideHelp();
    }

    render() {
        const { immExternalTransferFund, immBrokerMyInvestments, reset, immFundsList } = this.props;
        const immFunds = immBrokerMyInvestments.getIn(['products','funds','stocks']);
        let content =  (
            <ExternalTransferFundSuccess
                immExternalTransferFund={immExternalTransferFund}
                immFunds={immFunds}
                reset={reset}
            />
        );

        const title = formatText('brokerExternalTransferFundStep1-infoTitle');
        const boxBody = (
            <div>
                <div className="external-transfer-fund__info">
                    <FormattedText value="brokerExternalTransferFundStep1-infoContent"/>
                </div>
                <div className="external-transfer-fund__info">
                    <div><FormattedText value="brokerExternalTransferFundStep1-infoContent2"/></div>
                    <div><FormattedText value="brokerExternalTransferFundStep1-infoContent3"/></div>
                </div>
                <div className="external-transfer-fund__info">
                    <FormattedText value="brokerExternalTransferFundStep1-infoContent4"/>
                </div>
            </div>
        )

        let infoBox;
        if (immExternalTransferFund.get('visibleStep') === 1) {
            infoBox = (
                <ContentBox title={title} smallTitle={true}>
                    <div className="external-transfer-fund__info-box">
                        {boxBody}
                    </div>
                </ContentBox>
            );
        } else {
            infoBox = <ExternalTransferFundDetails immFundsList={immFundsList} immExternalTransferFund={immExternalTransferFund} immFunds={immFunds} />;
        }

        const specialistBox = (
            <div className="external-transfer-fund__specialist-box">
                <BrokerInvestmentSpecialist />
            </div>
        );

        if (immExternalTransferFund && !immExternalTransferFund.get('submitSuccessful')) {
            content = (
                <div>
                    <div className="col-xs-12 col-md-8">
                        {this.buildWizard()}
                    </div>
                    <div className="col-xs-12 col-md-4 grid-view--variable-cell-separation">
                        {infoBox}
                        {specialistBox}
                    </div>
                </div>
            );
        }

        if (immExternalTransferFund && immExternalTransferFund.get('showingHelp')) {
            content = <ExternalTransferFundHelp onHideHelp={this.handleHideHelp} />;
        }

        return content;
    }
}

ExternalTransferFund.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immSteps: PropTypes.object,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    requestProfile: PropTypes.func,
    immProfileFields: PropTypes.object,
    immPreContractualMail: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    resetPrecontractualMail: PropTypes.func,
    immBrokerFundLegalDocument: PropTypes.object.isRequired,
    immFundsList: PropTypes.object.isRequired,
    immExternalTransferFund: PropTypes.object.isRequired,
    getStocksContracts: PropTypes.func.isRequired,
    onHandleRetry: PropTypes.func.isRequired,
    handleInputSearchProductSelected: PropTypes.func.isRequired,
    handleResetSearchProductSelected: PropTypes.func.isRequired,
    handleSetSearchProductSelected: PropTypes.func.isRequired,
    setInstitutionName: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setNif: PropTypes.func.isRequired,
    setHasNif: PropTypes.func.isRequired,
    immBrokerMyInvestments: PropTypes.object.isRequired,
    setType: PropTypes.func.isRequired,
    setSubtype: PropTypes.func.isRequired,
    setAmount: PropTypes.func.isRequired,
    setDestinationFund: PropTypes.func.isRequired,
    setCheckbox: PropTypes.func.isRequired,
    getOriginFund: PropTypes.func.isRequired,
    getDestinationFunds: PropTypes.func.isRequired,
    getInterveners: PropTypes.func.isRequired,
    onHideHelp: PropTypes.func.isRequired,
    postValidation: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    fetchLegalDocuments: PropTypes.func.isRequired,
    resetAmountDirty: PropTypes.func.isRequired,
    onStartMifid: PropTypes.func.isRequired,
    onCancelMifid: PropTypes.func.isRequired,
    setLegalInformationConf: PropTypes.func,
    resetLegalInformation: PropTypes.func,
    onResetMifid: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
    resetPrintedIndicators: PropTypes.func.isRequired
};

module.exports = ExternalTransferFund;
